<template>
  <!-- START: Product view -->
  <div>
    <!-- START: Product row -->
    <div
      class="my-3 row"
      v-for="listItem in sortedList"
      :key="listItem.item.id"
      :aria-label="$t('selectProductManually')"
      @click.capture.stop="productManualSelection(listItem)"
    >
      <!-- START : Product list checkbox -->
      <div
        class="col-1 d-flex align-items-center justify-content-flex-start justify-content-lg-center"
      >
        <WCCheckbox
          :value="listItem.isSelected ? true : listItem.item.id"
          :model="listItem.isSelected"
          :ariaLabel="listItem.item.name"
          @change="productManualSelection(listItem)"
        />
      </div>
      <!-- END : Product list checkbox -->

      <!-- START : Product image -->
      <WCProductDetailsImage
        :item="listItem.item"
        :scanMode="true"
        class="col-3 col-md-2 pl-3 pl-lg-4"
      />
      <!-- END : Product image -->

      <!-- START : Product details -->
      <WCListProductDetails :listItem="listItem" :hasRemove="false" :scanMode="true" />
      <!-- END : Product details -->
    </div>
    <!-- END: Product row -->
  </div>
  <!-- END: Product view -->
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import WCProductDetailsImage from '@/modules/lists/components/WCProductDetailsImage/WCProductDetailsImage.vue';
import WCListProductDetails from '@/modules/lists/components/WCListProductDetails/WCListProductDetails.vue';

export default {
  name: 'ScanShoppingProductOverlayView',
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  inject: ['selectProductManually'],
  components: {
    WCCheckbox,
    WCProductDetailsImage,
    WCListProductDetails,
  },
  computed: {
    sortedList() {
      function compare(a, b) {
        if (a.item.shelfSequence < b.item.shelfSequence) return -1;
        if (a.item.shelfSequence > b.item.shelfSequence) return 1;
        return 0;
      }
      return this.products?.slice(0).sort(compare);
    },
  },
  methods: {
    /**
     * Select product manually
     */
    productManualSelection(data) {
      this.selectProductManually(data.item.id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.shopping-list-product__img {
  padding: $pad-1 $pad-2;
  height: rem(70px);
}

.product-container {
  height: rem(90px);
  border: 1px solid black;
  border-radius: 15px;
}

.rounded-circle {
  color: white !important;
  border: 1px solid black;
  border-radius: 50%;
}
</style>
